export enum InteractionEventTypeEnum {
  ResetJobSearchText,
}

export interface IInteractionEvent {
  eventType: InteractionEventTypeEnum;
  args?: any;
}
